import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { OptionWithVenn } from './type';
import { eachVennSeriesOption } from './helper/model';
import { parseRegionsColor } from './parseRegionsColor';
import { parseDefaultOption } from './parseDefaultOption';
import { parseRawData } from './parseRawData';
import { install as registerVennMapsExtension } from './registerVennMaps';
import { install as registerRegionLabelLayoutExtension } from './regionLabelLayout';
import { parseTitleStyle } from './parseTitle';

function parseVennOption(option: OptionWithVenn) {
  eachVennSeriesOption(option, series => {
    // 添加默认配置
    parseDefaultOption(series);
    // 解析处理原始数据
    parseRawData(series);
    // 解析并处理venn图各区块颜色的配置
    parseRegionsColor(series);
    // 解析venn图标题的默认配置
    parseTitleStyle(series);
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registerVennMapsExtension(registers);
  registers.registerPreprocessor(parseVennOption);
  registerRegionLabelLayoutExtension(registers);
}
